<div class="content-body">
  <app-breadcrumb [breadcrumb]="breadcrumbList"></app-breadcrumb>

  <div class="container-fluid">
  <div class="card">
    <div class="card-body">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center mb-3">
        <h5 class="heading mb-0">Enquiries Reports</h5>
        <div class="d-flex gap-2 align-items-center" *ngIf="checkDownloadPermission">
          <button
            class="btn btn-outline-danger btn-sm"
            (click)="downloadReport('pdf')"
            [disabled]="isDownloading">
            <span *ngIf="isDownloading && activeDownloadType === 'pdf'" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bi bi-file-earmark-pdf me-1" *ngIf="!isDownloading || activeDownloadType !== 'pdf'"></i>
            PDF
          </button>
          <button
            class="btn btn-outline-success btn-sm"
            (click)="downloadReport('csv')"
            [disabled]="isDownloading">
            <span *ngIf="isDownloading && activeDownloadType === 'csv'" class="spinner-border spinner-border-sm me-1"></span>
            <i class="bi bi-file-earmark-spreadsheet me-1" *ngIf="!isDownloading || activeDownloadType !== 'csv'"></i>
            CSV
          </button>
          <button
            class="btn btn-outline-primary btn-sm"
            (click)="openShareModal('email')"
            [disabled]="isDownloading">
            <i class="bi bi-envelope me-1"></i> Email
          </button>
          <button
            class="btn btn-outline-success btn-sm"
            (click)="openShareModal('whatsapp')"
            [disabled]="isDownloading">
            <i class="bi bi-whatsapp me-1"></i> WhatsApp
          </button>
          <span *ngIf="isDownloading" class="text-muted small ms-2">{{ downloadProgress }}</span>
        </div>
      </div>

      <!-- Filters -->
      <form [formGroup]="filterForm">
        <div class="row g-2 mb-3">
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Start Date</label>
            <input type="date" class="form-control form-control-sm" formControlName="start_date" (change)="onFilterChange()">
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">End Date</label>
            <input type="date" class="form-control form-control-sm" formControlName="end_date"
              [min]="filterForm.get('start_date')?.value" (change)="onFilterChange()">
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Property</label>
            <ng-select
              formControlName="property_id"
              [items]="propertiesItems"
              bindLabel="label"
              bindValue="value"
              placeholder="All Properties"
              [virtualScroll]="true"
              (scrollToEnd)="onPropertyScrollEnd()"
              (search)="searchProperty$.next($event.term)"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-2 col-sm-6">
            <label class="form-label">Platform</label>
            <ng-select
              formControlName="platform"
              [items]="platformOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="All"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-1 col-sm-6">
            <label class="form-label">Status</label>
            <ng-select
              formControlName="status"
              [items]="statusOptions"
              bindLabel="label"
              bindValue="value"
              placeholder="All"
              (change)="onFilterChange()"
              (clear)="onFilterChange()"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="col-md-1 col-sm-6 d-flex align-items-end">
            <button class="btn btn-outline-secondary btn-sm w-100" (click)="resetFilters()" [disabled]="!disableClear">
              Clear
            </button>
          </div>
        </div>
      </form>

      <!-- Summary Cards -->
      <div class="d-flex flex-wrap gap-2 mb-3" *ngIf="summaryData">
        <div class="summary-card bg-primary text-white">
          <div class="summary-value">{{ summaryData.total_enquiries }}</div>
          <div class="summary-label">Total Enquiries</div>
        </div>
        <div class="summary-card bg-danger text-white" *ngIf="summaryData.count_by_status?.['HOT'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['HOT'] || 0 }}</div>
          <div class="summary-label">Hot</div>
        </div>
        <div class="summary-card bg-warning text-dark" *ngIf="summaryData.count_by_status?.['WARM'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['WARM'] || 0 }}</div>
          <div class="summary-label">Warm</div>
        </div>
        <div class="summary-card bg-info text-dark" *ngIf="summaryData.count_by_status?.['COLD'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['COLD'] || 0 }}</div>
          <div class="summary-label">Cold</div>
        </div>
        <div class="summary-card bg-success text-white" *ngIf="summaryData.count_by_status?.['CONVERTED'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['CONVERTED'] || 0 }}</div>
          <div class="summary-label">Converted</div>
        </div>
        <div class="summary-card bg-secondary text-white" *ngIf="summaryData.count_by_status?.['REJECT'] !== undefined">
          <div class="summary-value">{{ summaryData.count_by_status['REJECT'] || 0 }}</div>
          <div class="summary-label">Rejected</div>
        </div>
      </div>

      <!-- Tabs -->
      <div class="d-flex justify-content-between align-items-end">
        <ul class="nav nav-tabs mb-0 flex-grow-1">
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'all'" (click)="switchTab('all')" href="javascript:void(0)">All Enquiries</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-status'" (click)="switchTab('by-status')" href="javascript:void(0)">By Status</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'by-platform'" (click)="switchTab('by-platform')" href="javascript:void(0)">By Platform</a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="activeTab === 'graphs'" (click)="switchTab('graphs')" href="javascript:void(0)">Graphs</a>
          </li>
        </ul>
        <div class="dropdown mb-1 ms-2" *ngIf="activeTab === 'all' && availableColumns.length"
            (click)="$event.stopPropagation()">
          <button class="btn btn-outline-secondary btn-sm dropdown-toggle" type="button"
              (click)="toggleColumnPicker()">
            <i class="bi bi-columns me-1"></i> Columns
          </button>
          <ul class="dropdown-menu dropdown-menu-end p-2 shadow" style="min-width: 220px;"
              [class.show]="showColumnPicker">
            <li *ngFor="let col of availableColumns" class="form-check">
              <input class="form-check-input" type="checkbox"
                  [id]="'enq-col-' + col.key"
                  [checked]="selectedColumnKeys.has(col.key)"
                  (change)="toggleColumn(col.key, $any($event.target).checked)">
              <label class="form-check-label" [for]="'enq-col-' + col.key">{{ col.label }}</label>
            </li>
          </ul>
        </div>
      </div>

      <!-- Tab Content -->
      <div class="tab-content">

        <!-- All Enquiries Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'all'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th *ngFor="let col of visibleColumns"
                      [class.text-end]="col.key === 'amount'">{{ col.label }}</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let enquiry of allEnquiriesData">
                  <td *ngFor="let col of visibleColumns"
                      [class.text-end]="col.key === 'amount'"
                      [class.report-wrap-cell]="col.wrap">
                    <ng-container [ngSwitch]="col.key">
                      <span *ngSwitchCase="'platform'" class="badge" [ngClass]="getPlatformClass(enquiry.platform)">{{ enquiry.platform }}</span>
                      <span *ngSwitchCase="'status'" class="badge" [ngClass]="getStatusClass(enquiry.status)">{{ enquiry.status }}</span>
                      <ng-container *ngSwitchCase="'amount'">{{ enquiry.amount != null ? (enquiry.amount | number:'1.0-0') : '-' }}</ng-container>
                      <ng-container *ngSwitchCase="'follow_up_date'">{{ $any(enquiry)[col.key] || '-' }}</ng-container>
                      <ng-container *ngSwitchCase="'created_at'">{{ $any(enquiry)[col.key] || '-' }}</ng-container>
                      <div *ngSwitchDefault [class.report-wrap-content]="col.wrap">{{ $any(enquiry)[col.key] || '-' }}</div>
                    </ng-container>
                  </td>
                </tr>
                <tr *ngIf="allEnquiriesData.length === 0">
                  <td [attr.colspan]="visibleColumns.length || 1" class="text-center text-muted py-3">No enquiries found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dataTables_paginate" *ngIf="pageCountAll > 1">
            <app-pagination [totalPage]="pageCountAll" [page]="pageAll" (newPage)="pageChangeAll($event)"></app-pagination>
          </div>
        </div>

        <!-- By Status Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'by-status'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th>Status</th>
                  <th class="text-end">Total Enquiries</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of byStatusData">
                  <td><span class="badge" [ngClass]="getStatusClass(row.status)">{{ row.status }}</span></td>
                  <td class="text-end">{{ row.total }}</td>
                </tr>
                <tr *ngIf="byStatusData.length === 0">
                  <td colspan="2" class="text-center text-muted py-3">No data found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dataTables_paginate" *ngIf="pageCountByStatus > 1">
            <app-pagination [totalPage]="pageCountByStatus" [page]="pageByStatus" (newPage)="pageChangeByStatus($event)"></app-pagination>
          </div>
        </div>

        <!-- By Platform Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'by-platform'">
          <div class="table-responsive">
            <table class="table table-hover table-sm mt-2">
              <thead>
                <tr>
                  <th>Platform</th>
                  <th class="text-end">Total Enquiries</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let row of byPlatformData">
                  <td><span class="badge" [ngClass]="getPlatformClass(row.platform)">{{ row.platform }}</span></td>
                  <td class="text-end">{{ row.total }}</td>
                </tr>
                <tr *ngIf="byPlatformData.length === 0">
                  <td colspan="2" class="text-center text-muted py-3">No data found</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="dataTables_paginate" *ngIf="pageCountByPlatform > 1">
            <app-pagination [totalPage]="pageCountByPlatform" [page]="pageByPlatform" (newPage)="pageChangeByPlatform($event)"></app-pagination>
          </div>
        </div>

        <!-- Graphs Tab -->
        <div class="tab-pane" [class.active]="activeTab === 'graphs'">
          <div class="row mt-3" *ngIf="summaryData">
            <!-- Enquiries by Status Chart -->
            <div class="col-md-6 mb-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">Enquiries by Status</h5>
                </div>
                <div class="card-body chart-container">
                  <div class="chart-bars">
                    <div class="chart-bar-item" *ngFor="let key of getSummaryKeys(summaryData.count_by_status)">
                      <span class="chart-bar-label">{{ key }}</span>
                      <div class="chart-bar-wrapper">
                        <div class="chart-bar"
                          [style.width.%]="summaryData.total_enquiries > 0 ? (summaryData.count_by_status[key] / summaryData.total_enquiries) * 100 : 0"
                          [ngClass]="{
                            'bg-danger': key === 'HOT',
                            'bg-warning': key === 'WARM',
                            'bg-info': key === 'COLD',
                            'bg-success': key === 'CONVERTED',
                            'bg-secondary': key === 'REJECT'
                          }">
                        </div>
                        <span class="chart-bar-value">{{ summaryData.count_by_status[key] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Enquiries by Platform Chart -->
            <div class="col-md-6 mb-3">
              <div class="card">
                <div class="card-header">
                  <h5 class="mb-0">Enquiries by Platform</h5>
                </div>
                <div class="card-body chart-container">
                  <div class="chart-bars">
                    <div class="chart-bar-item" *ngFor="let key of getSummaryKeys(summaryData.count_by_platform)">
                      <span class="chart-bar-label">{{ key }}</span>
                      <div class="chart-bar-wrapper">
                        <div class="chart-bar"
                          [style.width.%]="summaryData.total_enquiries > 0 ? (summaryData.count_by_platform[key] / summaryData.total_enquiries) * 100 : 0"
                          [ngClass]="{
                            'bg-danger': key === 'Magicbricks',
                            'bg-warning': key === '99acres',
                            'bg-primary': key === 'Housing',
                            'bg-success': key === 'Direct'
                          }">
                        </div>
                        <span class="chart-bar-value">{{ summaryData.count_by_platform[key] }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="!summaryData" class="text-center text-muted py-4">
            No data available for charts
          </div>
        </div>

      </div>
    </div>
  </div>
</div>

<!-- Share Modal -->
<div class="modal d-block" tabindex="-1" role="dialog" *ngIf="showShareModal" style="background-color: rgba(0,0,0,0.5);">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Share Report via {{ shareType === 'email' ? 'Email' : 'WhatsApp' }}</h5>
        <button type="button" class="btn-close" (click)="closeShareModal()"></button>
      </div>
      <form [formGroup]="shareForm">
        <div class="modal-body">
          <div class="mb-3">
            <label class="form-label">Search User</label>
            <ng-select
              formControlName="selectedUser"
              [items]="managersItems"
              bindLabel="label"
              bindValue="value"
              placeholder="Search by name..."
              (search)="searchManager$.next($event.term)"
              (change)="onShareUserChange($event)"
              class="select2-sm">
            </ng-select>
          </div>
          <div class="row mb-3">
            <div class="col-6">
              <label class="form-label">First Name</label>
              <input type="text" class="form-control form-control-sm" formControlName="first_name" placeholder="First name">
            </div>
            <div class="col-6">
              <label class="form-label">Last Name</label>
              <input type="text" class="form-control form-control-sm" formControlName="last_name" placeholder="Last name">
            </div>
          </div>
          <div class="mb-3" *ngIf="shareType === 'email'">
            <label class="form-label">Email Address</label>
            <input type="email" class="form-control form-control-sm" formControlName="email" placeholder="Enter email">
          </div>
          <div class="mb-3" *ngIf="shareType === 'whatsapp'">
            <div class="row">
              <div class="col-4">
                <label class="form-label">Code</label>
                <input type="text" class="form-control form-control-sm" formControlName="country_code" placeholder="+91">
              </div>
              <div class="col-8">
                <label class="form-label">WhatsApp Number</label>
                <input type="text" class="form-control form-control-sm" formControlName="whatsapp" placeholder="Enter number">
              </div>
            </div>
          </div>
          <div class="mb-3">
            <label class="form-label">File Type</label>
            <ng-select
              formControlName="file_type"
              [items]="reportTypeOptions"
              bindLabel="label"
              bindValue="value"
              [clearable]="false"
              class="select2-sm">
            </ng-select>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary btn-sm" (click)="closeShareModal()">Cancel</button>
          <button type="button" class="btn btn-primary btn-sm" (click)="submitShare()">
            <i class="bi" [ngClass]="{'bi-envelope': shareType === 'email', 'bi-whatsapp': shareType === 'whatsapp'}"></i>
            Send
          </button>
        </div>
      </form>
    </div>
  </div>
</div>
</div>
